<template>
  <div class="bg-round bg-fff">
    <div class="container mt-40 mb-40" id="app">
      <Bread class="ma-t-30" :list="[{ path: '', name: '志愿者招募' }]" />
      <div class="line-height-35 pa-t-20">
        <h2 class="t-center">志愿者招募</h2>
        <div>
          1、展映助理<br />
          需有一定的策展组织能力，熟悉影视类展映交流活动与校园活动，能协助在校园组织线上与线下的展映交流活动。<br /><br />

          2、海外展映助理<br />
          需有一定的策展组织能力，熟悉影视类展映交流活动与校园活动，能协助在校园组织线上与线下的展映交流活动。<br /><br />

          3、采访撰稿<br />
          独立采访、图文编写整理、发布采访文章<br /><br />

          4、影评撰稿<br />
          对影片提出独立的建议与看法，分享观影感受，整理写成影评。<br /><br />

          5、媒体统筹<br />
          需要一定的相关经验与部分媒体资源，并能拓展媒体相关资源。<br /><br />

          6、平面设计师<br />
          影片海报设计、活动海报设计<br /><br />

          7、创意编导<br />
          能独立创意、策划、拍摄、制作相关宣传、采访、活动视频短片。<br /><br />

          8、文本翻译：英文/法文/韩文/日文<br /><br />

          9、同传翻译：英文/法文/韩文/日文<br /><br />

          10、自我推荐<br /><br />

          除上述内容之外，您可以告诉我们：您的特长及您的想法。<br /><br />

          <h2 class="t-center">志愿者服务与管理协议</h2>

          <div class="fon-18 bold">招募服务岗位</div>
          <div></div>

          <div class="fon-18 bold">关于志愿者</div>
          <div>
            志愿者(Volunteer)联合国定义为“自愿进行社会公共利益服务而不获取任何利益、金钱、名利的活动者”，具体指在不为任何物质报酬的情况下，能够主动承担社会责任而不获取报酬，奉献个人时间和行动的人。<br /><br />
          </div>

          <div class="fon-18 bold">志愿者应征要求</div>
          <div>
            1、年龄在18周岁以上，身心健康；<br />
            2、具有奉献精神，责任感，包容的心态，正确的三观，耐心，热心社会工作公益事业，愿意利用自己的业余时间无偿提供服务；能够保证服务时间、注重服务质量、服务态度端正。<br />
            3、能够自觉遵守本社区的各项规章制度和志愿者纪律；按时参加志愿者相关会议与培训；<br />
            4、热爱影视事业，具有影视/传媒/新闻/文艺/文化活动类的一般基础认知，能够使用普通话和规范用语；<br />
            5、志愿者不限国籍。<br /><br />
          </div>

          <div class="fon-18 bold">志愿者报名方式</div>
          <div>
            1、官网注册，进入志愿者页报名，提交申请资料，进入初审。<br />
            2、初审通过后，复审考核，考核通过后正式登记成为“翠麟国际创作人社区志愿者”。<br /><br />
          </div>

          <div class="fon-18 bold">志愿者福利</div>
          <div>
            1、获得与国内外优秀电影人交流与学习的机会。<br />
            2、加入志愿者社群，拓展人脉，寻找志同道合的伙伴。<br />
            3、姓名、相片展示于官网志愿者页面。<br />
            4、志愿者NFT证书。<br />
            5、提供相关专业指导与培训的机会。<br />
            6、根据工作能力与意愿，推荐影视相关的实践实习机会。<br />
            7、参加本社区所有赛事报名，免报名费。<br />
            8、官网所有线上与线下活动优先邀请。<br />
            9、优秀者优先考虑晋升加入策展团队。<br />
            10、优秀者享有长期资源优先合作权。<br /><br />
          </div>

          <div class="fon-18 bold">志愿服务工作须知</div>
          <div>
            1、积极主动配合完成本社区交付的服务任务。<br />
            2、本社区提供实践实习学习的机会，志愿者在参与完成志愿服务工作期间，由本社区交由志愿者所协助或独立完成的所有相关策划、策展、创意、图文设计、撰稿、视频、音频等工作内容，相关版权归本社区所有，非志愿者的个人作品版权与署名，志愿者无权个人使用，如需使用需要获得本社区同意或授权，否则视为侵权行为，将自行承担相应法律责任。本社区享有直接使用、修改、截取部分、展示宣传等权利，无需另行告知。<br />
            3、服务工作中如遇到任何问题，应积极友好的与相关负责人主动沟通，不应打扰占用其他志愿者的时间与公共资源。<br />
            4、本社区享有所有活动及相关文宣的最终解释权。<br /><br />
          </div>

          <div class="fon-18 bold">退出须知</div>
          <div>
            1、志愿者可以主动提出退出要求。<br />
            2、本社区主动劝退或辞退。<br />
            3、本社区两次连续联系志愿者，无回复者，视为主动直接推出志愿者服务岗位与志愿者团队，不在享有本社区志愿者称号及相关荣誉资格。<br /><br />
          </div>

          <div>本协议的最终解释与修改权归本社区所有。</div>
        </div>
        <div class="form">
          <div class="bold form-title">个人资料</div>
          <div class="row f-center">
            <div class="col-md-2 t-md-right">个人头像</div>
            <div class="col-md-5">
              <el-upload
                action="http://api.shisw.net/V1/Common/AliyunOSS/Base64Upload"
                ref="uploadHeadimageHeadimage"
                show-file-list="true"
                :http-request="httpRequest"
                list-type="picture"
                :before-upload="beforeAvatarUploadHeadimage"
                :on-remove="handleRemove"
                :limit="1"
              >
                <div class="btn-upload">上传图片</div>
              </el-upload>
            </div>
          </div>
          <div class="row f-center">
            <div class="col-md-2 t-md-right">姓名</div>
            <div class="col-md-5">
              <el-input v-model="formData.Name" placeholder=""></el-input>
            </div>
          </div>
          <div class="row f-center">
            <div class="col-md-2 t-md-right">报名服务类型</div>
            <div class="col-md-5">
              <el-input v-model="formData.Type" placeholder=""></el-input>

              <!-- <el-select v-model="formData.Type" placeholder="请选择">
                            <el-option v-for="item in options" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select> -->
            </div>
          </div>
          <div class="row f-center">
            <div class="col-md-2 t-md-right">手机号码</div>
            <div class="col-md-5">
              <el-input v-model="formData.Phone" placeholder=""></el-input>
            </div>
          </div>
          <div class="row f-center">
            <div class="col-md-2 t-md-right">邮箱</div>
            <div class="col-md-5">
              <el-input v-model="formData.Email" placeholder=""></el-input>
            </div>
          </div>
          <div class="row f-center">
            <div class="col-md-2 t-md-right">微信号</div>
            <div class="col-md-5">
              <el-input v-model="formData.Wechat" placeholder=""></el-input>
            </div>
          </div>
          <div class="row f-center">
            <div class="col-md-2 t-md-right">简历</div>
            <div class="col-md-5">
              <el-upload
                action="http://api.shisw.net/V1/Common/AliyunOSS/Base64Upload"
                ref="uploadHeadimageFile"
                show-file-list="true"
                :http-request="httpRequestFile"
                :before-upload="beforeAvatarUploadFile"
                :on-remove="handleRemoveFile"
                :limit="1"
              >
                <div class="btn-upload">上传附件</div>
              </el-upload>
            </div>
          </div>
          <div class="row f-center">
            <div class="col-md-2 t-md-right"></div>
            <div class="col-md-8">
              本人已经仔细阅读上面所有内容，是否同意遵守本志愿者服务与管理协议。是
              <el-checkbox
                placeholder=""
                v-model="consent"
                size="medium"
              ></el-checkbox>
            </div>
          </div>
          <!-- <div class="row f-center">
                    <div class="col-md-2 t-md-right">推荐码</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.Code" placeholder=""></el-input>
                    </div>
                </div> -->
        </div>
        <div>
          <div class="btn-next" @click="save">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "../../../css/bootstrap.min.css";
@import "../../../css/commons.css";

.btn-next {
  width: 300px;
  height: 50px;
  line-height: 50px;
  color: #fff;
  border-radius: 10px;
  text-align: center;
  background-color: #fb004d;
  margin: 40px auto;
  cursor: pointer;
}

.form {
  border: 1px solid #dcdfe6;
  margin-top: 20px;
  padding: 20px;
  border-radius: 5px;
}

.form-title {
  background-color: #fff;
  padding: 2px 5px;
  position: relative;
  top: -40px;
  left: 10px;
  display: inline-block;
}

.form input {
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  width: 100%;
}

.form .row {
  margin-top: 20px;
}

.btn-upload {
  width: 120px;
  height: 50px;
  line-height: 50px;
  background-color: #fb004d;
  color: #fff;
  border-radius: 5px;
  text-align: center;
}

[v-cloak] {
  display: none;
}
</style>
<script>
var _this;
import {
  aliupload,
  getVolunteerAdd,
  postBase64Upload,
  postFileUpload,
} from "../../api.js";
export default {
  name: "merge",
  data() {
    return {
      formData: {
        Name: "",
        Type: "",
        Phone: "",
        Email: "",
        Wechat: "",
        Code: "",
        ImageUrl: "",
        Url: "", //附件
        UrlName: "",
        consent: false,
      },
      AliyunOSS: {},
      options: [
        "SHISW宣传大使",
        "城市展映统筹",
        "校园展映统筹",
        "校园自媒体号",
        "采访撰稿",
        "影评撰稿",
        "媒体联络",
        "插画师",
        "漫画师",
        "平面设计师",
        "创意短视频策划/拍摄/制作",
        "动画制作",
        "平面摄影师",
        "摄像师",
        "中英文翻译（文本）",
        "同声传译翻译",
      ],
    };
  },
  created() {
    _this = this;
    _this.loadDataUploadFile();
  },
  methods: {
    //保存
    save() {
      if (!_this.formData.ImageUrl) {
        _this.$message.error("个人头像数据为空");
        return false;
      }
      if (!_this.formData.Name) {
        _this.$message.error("姓名数据为空");
        return false;
      }
      if (!_this.formData.Type) {
        _this.$message.error("报名类型数据为空");
        return false;
      }
      if (!_this.formData.Phone) {
        _this.$message.error("手机号码据为空");
        return false;
      }
      if (!_this.formData.Email) {
        _this.$message.error("邮箱数据为空");
        return false;
      }
      if (!_this.formData.Wechat) {
        _this.$message.error("微信数据为空");
        return false;
      }
      if (!_this.formData.Url) {
        _this.$message.error("简历数据为空");
        return false;
      }
      if (!_this.consent) {
        _this.$message.error("请先同意志愿者服务与管理协议");
        return false;
      }

      //格式验证

      getVolunteerAdd(_this.formData).then(() => {
        _this.$message.success("提交成功");
        //清空
        for (const key in _this.formData) {
          _this.formData[key] = "";
        }
        _this.$refs.uploadHeadimageHeadimage.clearFiles();
        _this.$refs.uploadHeadimageFile.clearFiles();
      });
    },
    //获取文件上传oss参数
    loadDataUploadFile() {
      aliupload({ folder: "volunteer" }).then((res) => {
        _this.AliyunOSS = res.data.Data;
      });
    },
    //图片上传前-个人照
    beforeAvatarUploadHeadimage(file) {
      console.log(file);
      return true;
    },
    //文件上传，自定义上传方式，上传头像
    httpRequest(e) {
      console.log(e);
      _this.getBase64(e.file).then((res) => {
        postBase64Upload({
          Base64: res,
          Folder: "sign",
        }).then((res) => {
          if (res.data.Code != 0) {
            alert(res.data.Message);
            return false;
          }
          _this.formData.ImageUrl = res.data.Data.FilePath;
          return true;
        });
      });
    },
    //文件上传，自定义上传方式，上传简历
    httpRequestFile(e) {
      console.log(e);
      let postData = new FormData();
      postData.append("File", e.file);
      postData.append("Folder", "volunteer");
      postFileUpload(
        postData,
        {
          "Content-Type": "multipart/form-data",
        },
        false
      ).then((res) => {
        if (res.data.Code != 0) {
          _this.$message.error("上传失败");
          return false;
        }
        _this.$message.success("上传成功");
        _this.formData.UrlName = e.file.name;
        _this.formData.Url = res.data.Data.FilePath;
        return true;
      });
    },
    // 获取图片转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    //删除图片，头像
    handleRemove(file, fileList) {
      console.log(file);
      console.log(fileList);
    },
    //删除文件
    handleRemoveFile(file, fileList) {
      console.log(file);
      console.log(fileList);
    },
    //文件上传前
    beforeAvatarUploadFile() {},
  },
};
</script>
